import React from 'react';
import {Router, IndexRoute, Route, Link} from 'react-router';
import App from 'App';
import EditView from 'views/EditView';
import LoginView from 'views/LoginView';
import Cliser from 'cliser';
import AuthView from 'views/AuthView';

function onEnter(nextState, replaceState) {
  let token = window.localStorage.getItem("token");
  if (nextState.location.pathname !== '/login' && !token) {
    replaceState('/login');
  }
}

export default (
  <Route path="/" component={App}>
    <IndexRoute component={EditView} onEnter={onEnter} />
    <Route path="/login" component={LoginView}/>
    <Route path="/auth/callback/:token" component={AuthView}/>
    <Route path="/auth/error" component={AuthView}/>
    <Route path=":id" component={EditView} onEnter={onEnter}/>
  </Route>
)



// WEBPACK FOOTER //
// ./client/config/routing.js